export default __webpack_public_path__ + "static/media/save_device_config.c032f2f0.svg";